import type { TokenPair } from './types'

const STORAGE_KEY = 'transcoder.auth'

export interface StoredTokens {
  accessToken: string
  refreshToken: string
}

// Tokens are kept in localStorage so a reload keeps the session. Access
// tokens are short-lived (15 min); refresh tokens are revoked server-side on
// logout-all, password/role change or disable.
export const tokenStore = {
  get(): StoredTokens | null {
    try {
      const raw = localStorage.getItem(STORAGE_KEY)
      if (!raw) return null
      const parsed = JSON.parse(raw) as Partial<StoredTokens>
      if (typeof parsed.accessToken !== 'string' || typeof parsed.refreshToken !== 'string') return null
      return { accessToken: parsed.accessToken, refreshToken: parsed.refreshToken }
    } catch {
      return null
    }
  },
  set(pair: TokenPair): void {
    const value: StoredTokens = { accessToken: pair.access_token, refreshToken: pair.refresh_token }
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(value))
    } catch {
      // Storage unavailable (private mode): session lasts until reload.
    }
  },
  clear(): void {
    try {
      localStorage.removeItem(STORAGE_KEY)
    } catch {
      // ignore
    }
  },
}
